import * as ambassadorWixInnovationAssistantV2Statistics from './innovation-assistant-v2-statistics-statistics.http.js';
import * as ambassadorWixInnovationAssistantV2StatisticsTypes from './innovation-assistant-v2-statistics-statistics.types.js';
import * as ambassadorWixInnovationAssistantV2StatisticsUniversalTypes from './innovation-assistant-v2-statistics-statistics.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getStatistics(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixInnovationAssistantV2StatisticsUniversalTypes.GetStatisticsRequest,
  ambassadorWixInnovationAssistantV2StatisticsTypes.GetStatisticsRequest,
  ambassadorWixInnovationAssistantV2StatisticsUniversalTypes.GetStatisticsResponse,
  ambassadorWixInnovationAssistantV2StatisticsTypes.GetStatisticsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixInnovationAssistantV2Statistics.getStatistics(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/statistics',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Statistics as StatisticsOriginal,
  Daily as DailyOriginal,
  ChatHandler as ChatHandlerOriginal,
  ChatHandlerWithLiterals as ChatHandlerWithLiteralsOriginal,
  Timespan as TimespanOriginal,
  Period as PeriodOriginal,
  PeriodWithLiterals as PeriodWithLiteralsOriginal,
  GetStatisticsRequest as GetStatisticsRequestOriginal,
  GetStatisticsResponse as GetStatisticsResponseOriginal,
} from './innovation-assistant-v2-statistics-statistics.types.js';
